import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { http, messageError } from "./base";

export function fetchSelf() {
  return http.get("/users/self/").pipe(
    map(({ data }: any) => {
      return data;
    }),
    catchError(() => throwError("Unable to get self."))
  );
}

export function login(email: string, password: string) {
  return http.post("/token/", { email, password }).pipe(
    map(({ data }: any) => {
      return data;
    }),
    catchError((error) => messageError(error, "Unable to log in."))
  );
}

export function createUser(
  email: string,
  password: string,
  firstName: string,
  lastName: string
) {
  return http.post("/users/", { email, password, firstName, lastName }).pipe(
    map(({ data }) => {
      return data;
    }),
    catchError((error) => messageError(error, "Error occurred when signing up. Please try again."))
  );
}
